<script setup lang="ts">
defineOptions({name: 'AuthMethodTabs'});

withDefaults(defineProps<{
    modelValue: string;
    methods: ReadonlyArray<{value: string; label: string}>;
    /** Layout — login page uses centered, the in-modal pickers use the default left-aligned. */
    centered?: boolean;
    /** Optional prefix for per-tab data-test attributes (e.g. "tab" → tab-mobile-id). */
    dataTestPrefix?: string;
}>(), {
    centered: false,
    dataTestPrefix: ''
});

const emit = defineEmits<{
    (e: 'update:modelValue', value: string): void;
}>();
</script>

<template>
    <div
        class="merit-auth-method-tabs"
        :class="{ 'merit-auth-method-tabs--centered': centered }"
        role="tablist"
    >
        <button
            v-for="m in methods"
            :key="m.value"
            type="button"
            class="merit-auth-method-tabs__pill"
            :class="{ 'merit-auth-method-tabs__pill--active': modelValue === m.value }"
            role="tab"
            :aria-selected="modelValue === m.value"
            :data-test="dataTestPrefix ? `${dataTestPrefix}-${m.value}` : undefined"
            @click="emit('update:modelValue', m.value)"
        >
            {{ m.label }}
        </button>
        <slot/>
    </div>
</template>

<style scoped>
.merit-auth-method-tabs {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-bottom: 20px;
}

.merit-auth-method-tabs--centered {
    justify-content: center;
}

.merit-auth-method-tabs__pill {
    background: #fff;
    border: 1px solid #c1c1c1;
    border-radius: 999px;
    padding: 6px 12px;
    font-size: 12px;
    line-height: 1.2;
    white-space: nowrap;
    color: #333;
    cursor: pointer;
    transition: background-color 120ms ease, border-color 120ms ease, color 120ms ease;
}

.merit-auth-method-tabs__pill:hover {
    border-color: #2eb336;
    color: #2eb336;
}

.merit-auth-method-tabs__pill--active,
.merit-auth-method-tabs__pill--active:hover {
    background: #2eb336;
    border-color: #2eb336;
    color: #fff;
}
</style>
